const url={
	devUrl:'http://192.168.2.114:8200',//'https://a.vormor.cn',
	//proUrl:'http://192.168.2.114:8200',
	proUrl:'https://a.vormor.cn',
}
export const baseUrl =process.env.NODE_ENV === 'development'? url.devUrl: url.proUrl;